import { createFileRoute } from "@tanstack/react-router"

import { uomLoader } from "@/screens/WarehouseReceiving/loaders"
import { SoftReceivedGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/SoftReceived/components"

export const Route = createFileRoute("/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => <SoftReceivedGoodsReceiptDetailsLayout />,
})
